<template>
  <div class="product">
    <div class="banner">
      <div class="title">智能内容管理</div>
      <div class="desc">
        <section>为企业搭建内容中心，提供平台级的内容生产协作及数字资产的存储、管理、共享，</section>
        <section>提升企业全域的内容分发效率，保障品牌资产的规范统一</section>
      </div>
      <router-link target="_blank"  to='/contact'>
        <div class="button">立即体验
          <i class="el-icon-right"></i>
        </div>
      </router-link>
    </div>
    <div class="context">
      <div class="manage_item" v-for="(item, index) in contentList" :key="index">
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_content" :style="{flexDirection: index % 2 === 0 ? 'row' : 'row-reverse'}">
          <div class="content_left" :style="{
            marginRight: index % 2 === 0 ? '40px' : '0',
            marginLeft: index % 2 !== 0 ? '75px' : '0'
          }">
            <div class="left_wrap" :style="{ width: item.leftWidth, marginRight: item.margin, paddingTop: item.top }">
              <div class="left_item" v-for="(ele, ind) in item.leftChildren" :key="ind">
                <div class="left_item_title">
                  <span class="icon"></span>
                  <span class="text">{{ ele.title }}</span>
                </div>
                <div class="left_item_desc">{{ ele.desc }}</div>
              </div>
              <router-link target="_blank"  to='/contact'><div class="button">了解更多<i class="el-icon-right"></i></div></router-link>
            </div>
            <div class="right_wrap" v-if="item.rightChildren"  :style="{ width: item.rightWidth, paddingTop: item.top }">
              <div class="right_item" v-for="(ele, ind) in item.rightChildren" :key="ind">
                <div class="right_item_title">
                  <span class="icon"></span>
                  <span class="text">{{ ele.title }}</span>
                </div>
                <div class="right_item_desc">{{ ele.desc }}</div>
              </div>
            </div>
          </div>
          <div class="content_right">
            <img :src="item.url" alt="">
          </div>
        </div>
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/productBanner.vue'
export default {
  name: 'manage',
  components: {
    banner,
  },
  data() {
    return {
      contentList: [
        {
          title: '营销素材收集与整理',
          desc: '营销内容数字化沉淀管理，提高内容复用率',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/manage/manage1.png',
          leftWidth: '270px',
          rightWidth: '270px',
          margin: '32px',
          top: '80px',
          leftChildren: [
            {
              title: '企业自有素材',
              desc: '企业自有图片素材、已购版权内容、字体等'
            },
            {
              title: '内容代理创作素材',
              desc: '广告公司等供应商创作的素材等'
            }
          ],
          rightChildren: [
            {
              title: 'UGC创作素材',
              desc: '社交媒体平台KOL、KOC等UGC内容'
            }
          ]
        },
        {
          title: '智能合规审核',
          desc: '多种合规检测能力，让违规内容无所遁形',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/manage/manage2.png',
          leftWidth: '196px',
          rightWidth: '294px',
          margin: '47px',
          top: '39px',
          leftChildren: [
            {
              title: '一般通用型检测',
              desc: '涉黄涉暴涉政涉恐内容智能检测'
            },
            {
              title: '广告法检测',
              desc: '智能广告法合规检测'
            },
            {
              title: '自定义敏感词检测',
              desc: '企业自定义敏感词库智能检测'
            }
          ],
          rightChildren: [
            {
              title: '肖像权检测',
              desc: '名人肖像权智能检测，肖像权时效设定'
            },
            {
              title: '版权标记',
              desc: '版权素材时效性设定'
            },
            {
              title: '有效期标记',
              desc: '内容素材有效期设定确保保密期的物料不被泄露'
            }
          ]
        },
        {
          title: '标签体系',
          desc: '内容信息结构化解析，企业内容统一“内容协议”',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/manage/manage3.png',
          leftWidth: '270px',
          rightWidth: '270px',
          margin: '32px',
          top: '31px',
          leftChildren: [
            {
              title: '属性信息',
              desc: '利用AI及MD5提取文件基础信息，如文件格式、尺寸、创建者等信息关键词'
            },
            {
              title: '管理标签',
              desc: '根据管理需求，对内容的使用和限制进行的管理标签'
            }
          ],
          rightChildren: [
            {
              title: '智能识别',
              desc: '利用视觉、语音、OCR、关键词提取等AI技术，识别出场景、logo、公众人物、地点、文字、语音等泛标签关键词'
            },
            {
              title: '产品标签',
              desc: '针对品牌标签体系进行定制化专项模型训练，智能提取品牌SKU、型号等其他更细致的特征信息'
            }
          ]
        },
        {
          title: '智能搜索',
          desc: '多维度搜索/检索方式，让目标内容无处可藏',
          url: 'https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/manage/manage4.png',
          leftWidth: '464px',
          top: '26px',
          leftChildren: [
            {
              title: '关键词搜索',
              desc: '可通过文件关键词进行搜索，搜索范围涵盖文件名、分类标签、智能标签、属性、备注等'
            },
            {
              title: '条件检索',
              desc: '可通过条件进行过滤检索，如文件类型、日期、格式、标签、时长、大小等'
            },
            {
              title: '分类检索',
              desc: '可按文件基础分类进行检索，如图片、视频、音频、文档、字体、其他等'
            }
          ]
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.product{
    width: 100%;
    min-width: 1400px;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/product/manage/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 32px;
      }

    }
    .context{
      width: 1200px;
      margin: auto;
      .manage_item {
        margin-top: 80px;
        &:last-child {
          margin-bottom: 60px;
        }
        .item_title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #3B3946;
          line-height: 45px;
          text-align: center;
          margin-bottom: 16px;
        }
        .item_desc {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6E6C76;
          line-height: 22px;
          text-align: center;
          margin-bottom: 54px;
        }
        .item_content {
          display: flex;
          .content_left {
            width: calc(100% - 588px);
            display: flex;
            .left_item, .right_item {
              display: inline-block;
              margin-bottom: 24px;
              .left_item_title, .right_item_title {
                display: flex;
                align-items: center;
                .icon {
                  width: 12px;
                  height: 6px;
                  background-color: #5A2DF5;
                  margin-right: 8px;
                }
                .text {
                  font-size: 20px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #3B3946;
                  line-height: 28px;
                }
              }
              .left_item_desc, .right_item_desc {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #6E6C76;
                line-height: 24px;
                margin-top: 8px;
              }
            }
          }
          .content_right {
            flex-shrink: 0;
            width: 588px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        &:nth-child(3) {
          .left_item {
            height: 108px;
          }
        }
      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        margin-top: 8px;
        .el-icon-right{
          display: none;
          margin-left: 8px;
        }
        &:hover{
          .el-icon-right{
            display: block;
            color: #FFFFFF;
            margin-left: 8px;
          }
        }
      }
}
.marginTop{
  margin-top: 8px;
}
</style>
